import { createContext, useContext } from 'react'

/**
 * Context that carries the DOM element used as the portal target for
 * route-level toolbars (e.g. PrivateDocumentsAppBar, QuotesDashboardToolbar).
 *
 * The element is produced by MainAppBar attaching a callback ref to its
 * toolbar Box. Consumers (AppBarPortal) portal their children into that
 * element. Using Context + ref callback avoids the DOM-query race that
 * affected Firefox when the portal source rendered before the target div
 * had been committed to the DOM.
 */
const AppBarTargetContext = createContext({
    target: null,
    setTarget: () => {},
})

export const useAppBarTarget = () => useContext(AppBarTargetContext).target

export const useSetAppBarTarget = () => useContext(AppBarTargetContext).setTarget

export default AppBarTargetContext
